<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 5C4 3.34315 5.34315 2 7 2H19C19.5523 2 20 2.44772 20 3V17C20 17.5523 19.5523 18 19 18V20C19.5523 20 20
      20.4477 20 21C20 21.5523 19.5523 22 19 22H7C5.34315 22 4 20.6569 4 19V5ZM7 4C6.44772 4 6 4.44771 6 5V16H18V4H7ZM6
      19C6 18.4477 6.44772 18 7 18H17V20H7C6.44771 20 6 19.5523 6 19ZM9 6C8.44772 6 8 6.44772 8 7V13C8 13.5523 8.44772
      14 9 14C9.55228 14 10 13.5523 10 13V8.47301C10 8.21177 10.2118 8 10.473 8C10.7342 8 10.946 8.21177 10.946
      8.47301V13C10.946 13.5523 11.3937 14 11.946 14H15C15.5523 14 16 13.5523 16 13V7C16 6.44772 15.5523 6 15 6C14.4477
      6 14 6.44772 14 7V11.473C14 11.7641 13.7641 12 13.473 12C13.182 12 12.946 11.7641 12.946 11.473V7C12.946 6.44772
      12.4983 6 11.946 6H9Z"
    />
  </svg>
</template>
